<div class="container-fluid mt-2">

  <p-toolbar>
    <div class="p-toolbar-group-left">
      <div translate class="filtro ng-star-inserted sm-font" style="margin: 0px 10px 0px 0px;">
        {{'businessIntelligence.registro1Servico.dataReferencia'}}
      </div>
      <p-dropdown [options]="anoDropDown" [(ngModel)]="filtros.dataAno" (onChange)="setaValorData()" optionLabel="name"
        optionValue="code" [style]="{ 'width': '150px' }">
      </p-dropdown>

      <p-radioButton label="Todos os tipos" styleClass="ml-2 mt-2" [value]="true" [(ngModel)]="filtros.selecaoVdm"
        (onClick)="alteraValorFiltroVdm()">
      </p-radioButton>
      <p-radioButton label="Somente válidas para VDM" styleClass="ml-2 mt-2" [value]="false"
        [(ngModel)]="filtros.selecaoVdm" (onClick)="alteraValorFiltroVdm()"></p-radioButton>
      <p-checkbox label="Considerar Balcão" styleClass="ml-2 customcheckbox" binary="false"
        [(ngModel)]="filtros.considerarBalcao" (onChange)="alteraValorFiltroVdm()">
      </p-checkbox>
    </div>
    <div class="p-toolbar-group-right">
      <button pButton class="p-button-outlined p-button-secondary p-button-sm mr-2" type="button"
        (click)="exportExcel()">
        <i class="fa fa-download mr-1"></i>Export Excel
      </button>
      <p-button class="flex" (click)="retornaDados()" icon="pi pi-refresh" styleClass="p-button-sm"></p-button>
    </div>
  </p-toolbar>

  <p-panel header="Apuração VDM - Acessórios" styleClass="p-shadow-3">
    <p-table #dt [columns]="cols" [value]="dados" [rowHover]="true" [loading]="loading" [scrollable]="true"
      scrollHeight="50vh"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
      sortMode="multiple" [globalFilterFields]="['codDealer']" paginatorDropdownAppendTo="body">

      <ng-template #message pTemplate="emptymessage" let-columns>
        <tr *ngIf="dados?.length != 0">
          <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
            style="padding: 20px;">
            <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="2">
            Todos os Tipos
          </th>
          <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="7">
            Ano
          </th>
        </tr>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th [pSortableColumn]="col.field"
              style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
              [ngStyle]="{'width': col.width}">
              {{col.header}}
              <p-sortIcon [field]="col.field" class="p-sortable-colum"
                *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
              </p-sortIcon>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <div *ngIf="col.field != 'visivel'">
              <ng-container *ngIf="col.header === 'Realizado'; else checkPercent">
                <a 
                   style="color: blue; cursor: pointer; text-decoration: underline;"
                   (click)="downloadExcel(dados)">
                  {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field] }}
                </a>
              </ng-container>
              <ng-template #checkPercent>
                <ng-container *ngIf="col.field.includes('Percent') || col.header.includes('%'); else normal">
                  {{ dados[col.field] }}%
                </ng-container>
                <ng-template #normal>
                  {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field] }}
                </ng-template>
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer" let-dados>
        <tr>
          <td class="text-center" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
            colspan="2">
            Brasil
          </td>
          <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{totais.totalBudgetFull | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}
          </td>
          <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{totais.totalBudgetYtd | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}
          </td>
          <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{totais.totalRealizado | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}
          </td>
          <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{totais.totalValorDesconto | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}
          </td>
          <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{totais.totalValorComDesconto | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}
          </td>
          <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{totais.totalPendenteFull | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}
          </td>
          <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{totais.totalPendenteYtd | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="card" *ngIf="dados?.length === 0">
      <div class="card-body bg-no-records p-shadow-3">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </div>
    </div>

  </p-panel>

  <p-tabView styleClass="mt-3">
    <!-- <p-tabPanel header="Principal">
      <app-apuracao-vdm-acessorio-principal-jaguar #principal [filtros]="filtros"></app-apuracao-vdm-acessorio-principal-jaguar>
    </p-tabPanel> -->
    <p-tabPanel header="Histórico">
      <app-apuracao-vdm-acessorio-historico-jaguar #historicoJaguar [filtros]="filtros">
      </app-apuracao-vdm-acessorio-historico-jaguar>
    </p-tabPanel>
  </p-tabView>

  <p-tabView styleClass="mt-3">
    <!-- <p-tabPanel header="Principal">
      <app-apuracao-vdm-acessorio-principal-land-rover #principal [filtros]="filtros"></app-apuracao-vdm-acessorio-principal-land-rover>
    </p-tabPanel> -->
    <p-tabPanel header="Histórico">
      <app-apuracao-vdm-acessorio-historico-land-rover #historicoLandRover [filtros]="filtros">
      </app-apuracao-vdm-acessorio-historico-land-rover>
    </p-tabPanel>
  </p-tabView>

</div>
